import { BaseService } from "./BaseService";

export class AccountService extends BaseService {
  async authenticate(username, password, rememberMe, forceLogin) {
    return this.request("/api/Account/Authenticate", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify({ username, password, rememberMe, forceLogin }),
    });
  }

  changePassword(oldPassword, newPassword) {
    return this.request("/api/Account/ChangePassword", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify({ oldPassword, newPassword }),
    });
  }

  getAccesses() {
    return this.request("api/Account/GetAccesses/", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    });
  }

  async logOut() {
    return this.request("/api/Account/LogOut", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    });
  }

  recoverPassword(email) {
    return this.request("api/Account/RecoverPassword/", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(email),
    });
  }

  canRecoverPassword(hash) {
    return this.request("api/Account/CanRecoverPassword/", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(hash),
    });
  }

  useRecoverPassword(model) {
    return this.request("api/Account/UseRecoverPassword/", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(model),
    });
  }

  freeTrial(model) {
    return this.request("api/Account/FreeTrial/", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(model),
    });
  }

  getDailyUpdateConfig(model) {
    return this.request("api/Account/GetDailyUpdateConfig/", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    });
  }

  setDailyUpdateConfig(model) {
    return this.request("api/Account/SetDailyUpdateConfig/", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(model),
    });
  }

  getAccessReport(idAccess) {
    return this.request(`api/Account/GetAccessReport/${idAccess}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    });
  }

  disableDailyUpdate(idLetter, idUser) {
    return this.request(`api/Account/DisableDailyUpdate/${idLetter}/${idUser}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
    });
  }
}

const accountService = new AccountService();

export default accountService;
